import { spawn } from 'redux-saga/effects';
import { watchMyGames } from './my-games';

export function* myGamesSaga() {
  yield spawn(watchMyGames);
}
